import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { InsuranceType } from 'src/app/enums/insurance-type.enum';

import { LeadFormBase } from '../../lead-form-base';

@Component({
  selector: 'app-business-construction-form',
  templateUrl: './business-construction-form.component.html',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule],
})
export class BusinessConstructionFormComponent extends LeadFormBase {
  @Input()
  formGroup!: FormGroup;

  constructor(private fb: FormBuilder) {
    super();
  }

  metadataFormGroup: FormGroup = this.fb.group({
    type: InsuranceType.BUSINESS_CONSTRUCTION,
  });

  override ngOnInit(): void {
    super.ngOnInit();
    this.formGroup.removeControl('metadata');
    if (this.metadata) this.metadataFormGroup.patchValue(this.metadata);
    this.formGroup.addControl('metadata', this.metadataFormGroup);
  }
}
